import { GameManager } from '../../../manager/game_manager';
import Debug from '../../../manager/debug';
import VersionManager from '../../../manager/version_manager';
import LoaclStorage from '../../../manager/local_storage';
import AppController from '../../../sdk/app_controller';
import GameUtil from '../../../utility/game_util';
import TimeManager from '../../../manager/time_manager';
import Utility from '../../../utility/utility';
import LogManager from '../../../manager/log_manager';


export default class AppData {
    //版本信息，非常重要
    static appVersion: string = "1.3.0"
    //app产品号，游戏内显示的
    static appProductVersion: string = "2.1.0"
    static assetVersion: number = 0
    static internalAssetVersion: number = 0

    static serverCenter : string
    static serverCurGame : string

    //是否为测试模式，如果是测试模式那连得是测试环境
    static _testMode = false
    static apiLogMode = false

    static bundleId = "com.bigwin.dayingjia"

    static appName: string = "TM"
    static _gameName: string = "TM_LHD"
    //简易名字，没有"_"
    static gameSimpleName: string = "LHD"
    static SALT_A: string = "SbtATxjoo989000x*29lyp"
    static SALT_B: string = "SbtB009XVVWDVLXX89#S)X"
    static AESKey = "7tSswav9PZzS5qVY"

    static proxyHost: string = ""
    static httpApiMobileUrl: string
    static httpApiMessageUrl: string
    static apiHttpUrl: string
    static versionApiUrl: string

    static remoteVersionConfig
    static channelId = -1 //推广渠道号
    static isWidescreen: boolean = false //iphonex
    static designResolution: cc.Size
    static widescreenOffset = 50
    static language = "th"
    static apiLanguage = "th-TH"
    //zh-CN|en-US|th-TH
    static openUrl = ""
    //是否是从app打开的游戏
    static openFromApp: boolean = false;
    //打开游戏需要跳转的玩法,龙虎TM_LHD,德州TM_DZPK,黑杰克TM_HJK,抢庄TM_QZNN
    static openAppGameId: string = "HALL"

    static windowAppData

    static startCheckGame = false
    static alreadyShowHallScene = false

    static promoteUrl = null
    static appDownloadUrl = null
    //是否自动登录
    static autoLogin: boolean = false

    //是否进入了大厅,只有进入过一次就会变成true
    static showHall : boolean = false
    static showClubHall : boolean = false

    static inTable : boolean = false

    //客服地址
    static customerServiceUrl: string
    //版本获取地址
    static versionConfigUrl: string
    //用户连接的环境，0生产、1体验、2测试
    static userConnectEnvi = 0
    //开发环境，可以切换测试与体验环境
    static constHostDevelop: string = ""
    //生产环境
    static constHostProduct = "winner518.com"
    //httpdns获取到的ip
    static apiHostIp = ""

    //内存回收等级：0 为不回收，1为正常回收，2为极度回收
    static memoryRecyclingLevel = 0

    static openInstallData : {code ?: number, clubCode ?: number, clubId ?: number}

    static adParameter = {
        google : {
            anroid : "ca-app-pub-7253944231185611/4032530346",
            ios : "ca-app-pub-7253944231185611/6734369823",
            anroidTest : "ca-app-pub-3940256099942544/1712485313",
            iosTest : "ca-app-pub-3940256099942544/5224354917"
        },
        facebook : {
            anroid : "538366510361589_555641305300776",
            ios : "2847683335326470_2964534980307971"
        }
    }

    static gameNameToTableModule = {
        "BPZD": ["BiPaiTableModule"],
        "BP": ["BiPaiTableModule"],
        "JD": ["JdPokerTable"],
        "YXX": ["YXXTableModule", "RoadMap_yxx"],
        "TB": ["YXXTableModule", "RoadMap_tb"],
        "DZPK": ['TexasPokerTable'],
        "LHD": ["LongHuDouTableModule", "RoadMapInfo"],
        "QZNN": ["BankerBullBullTableModule"],
        "HJK": ["BlackJackTableModule"],
        'JK': ['K9TableModule'],
        "CP": ["CpTableModule"],
        "SLOT": ["SlotTableModule"],
        "BJL" :  ["BJLTableModule"],
        "Q2" :  ["Q2TableModule"],
    }

    static get gameName() {
        return this._gameName
    }
    static set gameName(value) {        
        this._gameName = value;
        this.gameSimpleName = value.split('_')[1]
    }

    static _devicesId = ""
    static _devicesModel = ""
    static _devicesOs = ""
    static get devicesId() {
        if (this._devicesId == "") {
            this.devicesInfo()
        }
        return this._devicesId
    }
    static get devicesModel() {
        if (this._devicesModel == "") {
            this.devicesInfo()
        }
        return this._devicesModel
    }
    static get devicesOs() {
        if (this._devicesOs == "") {
            this.devicesInfo()
        }
        return this._devicesOs
    }
    static devicesInfo(){
        let info = AppController.instance.deviceInfo()
        if (info) {
            this._devicesOs = info.os
            this._devicesModel = info.model
            this._devicesId = info.deviceId
        }
    }
    static userHttps = false


    static get testMode() {
        return this._testMode
    }

    static set testMode(value) {        
        this._testMode = value;
        if (value) {
            AppData.apiLogMode = true
            Debug.logOpen = true
        }
    }



    
    static setServerByData(userConnectEnvi, requestHttpDns?) {
        cc.log("setServerByData", userConnectEnvi, this.constHostDevelop)
        let apiHost, port, http, host
        //https wss 用8088端口
        port = AppData.userHttps ? ":8088" : ":8080"
        http = AppData.userHttps ? "https://" : "http://"
        if (userConnectEnvi == 0 || this.constHostDevelop == "" || this.constHostDevelop == "0") {
            host = this.constHostProduct
            apiHost = "api." + host
            userConnectEnvi = 0
        } else {
            if (userConnectEnvi == 2 || userConnectEnvi == 1) {
                host = this.constHostDevelop
                host = host.includes(":") ? host.substring(0, host.indexOf(":")) : host
                apiHost = (userConnectEnvi == 2 ? "test.api." : "api.") + host
            }
        }
        if (this.apiHostIp != "" && userConnectEnvi == 0) {    //httpdns
            apiHost = this.apiHostIp
        }
        cc.log("apihost:", apiHost)
        AppData.userConnectEnvi = userConnectEnvi
        AppData.proxyHost = http + apiHost + port + "/proxy?url="
        AppData.httpApiMobileUrl = http + apiHost + port + "/api/mobile/"
        AppData.apiHttpUrl = http + apiHost + port + "/api/"

        let ws = AppData.userHttps ? "wss://" : "ws://"
        let wsPort = AppData.userHttps ? ":8088" : ":8080"
        GameManager.loginServer = ws + apiHost + wsPort + "/login?type=token"
        GameManager.gameServer = ws + apiHost + wsPort + "/game?token="
        GameManager.hallServer = ws + apiHost + wsPort + "/hall?token="
        GameManager.notifyServer = ws + apiHost + wsPort + "/websocket?token="
        GameManager.clubHallServer = ws + apiHost + wsPort + "/hallx?token="

        if (userConnectEnvi == 2) {
            // AppData.customerServiceUrl = (cc.sys.isNative ? "http://" : http) + "test.custom." + host + port
            AppData.customerServiceUrl = "http://test.custom." + host + ":8080"
            AppData.versionConfigUrl = (cc.sys.isNative ? "http://" : http) + "test.ossclient." + host + "/config/" + (cc.sys.isNative ? Utility.platformName() : "web") + "/version.json"
        } else {
            // AppData.customerServiceUrl = (cc.sys.isNative ? "http://" : http) + "custom." + host + port
            AppData.customerServiceUrl = "http://custom." + host + ":8080"
            AppData.versionConfigUrl = (cc.sys.isNative ? "http://" : http) + "ossclient." + host + "/config/" + (cc.sys.isNative ? Utility.platformName() : "web") + "/version.json"
        }
        //@ts-ignore
        if (!window.appData || (!CC_JSB && AppData.openUrl.includes("/index_"))) {
            if (!CC_PREVIEW ) {
                AppData.versionConfigUrl = null
            }
            if (CC_JSB || CC_PREVIEW ) {
                AppData.versionConfigUrl = null
            }
        }


        cc.log("versionConfigUrl", AppData.versionConfigUrl)
        if (!AppData.startCheckGame && !requestHttpDns) {
            this.getIp(apiHost)
        }

    }


    static getIp(host, times?) {
        let self = this
        if (CC_JSB && !CC_PREVIEW &&this.userConnectEnvi == 0) {   //app正式服才使用httpdns
            let ips: string[] = AppController.instance.getIpsByHostAsync(host)
            cc.log("获取httpnds,", ips.length)
            if (ips.length > 0) {
                ips.forEach(ip => {
                    this.verifyIp(ip)
                });
            } else {
                cc.log("获取httpnds失败,", times)
                if (!times) {
                    times = 0
                }
                cc.log("getIp,times:", times)
                if (times <= 10) {
                    TimeManager.instance.doScheduleOnce(() => {
                        times += 1
                        self.getIp(host, times)
                    }, 1)
                }
            }
        }
    }

    static verifyIp(ip) {
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "http://" + ip + ":8080/api/getIp?",
            isApiRequest : false
        }
        GameUtil.apiHttpGet(requestData, (data) => {
            self.apiHostIp = ip
            this.setServerByData(self.userConnectEnvi, true)
        })
    }


    static init() {
        AppData.testMode = false
        if (!CC_JSB) {
            AppData.openUrl = window.location.href;
            AppData.userHttps = !cc.sys.isNative && AppData.openUrl.indexOf("https") >= 0
            AppData.openFromApp = GameUtil.getQueryString(window.location.search, "openFromApp") != null;
            AppData.autoLogin = GameUtil.getQueryString(window.location.search, "autoLogin") != null;
            AppData.startCheckGame = GameUtil.getQueryString(window.location.search, "startCheckGame") != null;
            let openGameId = GameUtil.getQueryString(window.location.search, "gameId");
            if (openGameId != null) {
                AppData.openAppGameId = openGameId;
            }
            if (Utility.openInFacebook()) {
                Utility.reportEffect("sys_platformOpenInFacebook")
            }
            if (Utility.openInLine()) {
                Utility.reportEffect("sys_platformOpenInLine")
            }
        }

        if (CC_PREVIEW) {
            AppData.testMode = true
        }
        //@ts-ignore
        let windowAppData = window.appData
        if (windowAppData) {
            AppData.windowAppData = windowAppData
            AppData.appVersion = windowAppData.internalAppVersion ? windowAppData.internalAppVersion : AppData.appVersion
            AppData.assetVersion = windowAppData.assetVersion ? parseInt(windowAppData.assetVersion) : AppData.assetVersion
            AppData.internalAssetVersion = windowAppData.internalAssetVersion ? windowAppData.internalAssetVersion : AppData.assetVersion
            if (windowAppData.bundleId) {
                AppData.bundleId = windowAppData.bundleId
            }
            if (windowAppData.userConnectEnvi) {
                AppData.userConnectEnvi = windowAppData.userConnectEnvi
                AppData.testMode = true
            }
            if (windowAppData.constHostDevelop) {
                AppData.constHostDevelop = windowAppData.constHostDevelop
                AppData.testMode = true
                LoaclStorage.setString("__customHostDevelop", AppData.constHostDevelop)
                LoaclStorage.setNumber("__isDevelopTestMode", AppData.userConnectEnvi)
            }
            if (windowAppData.buildDebug) {
                AppData.testMode = true
            }

            if (CC_JSB) {
                let userConnectEnv = LoaclStorage.getNumber("__userConnectEnvi", 0)
                if (userConnectEnv == 1 || userConnectEnv == 2) {
                    AppData.userConnectEnvi = userConnectEnv
                    AppData.testMode = userConnectEnv == 2
                }
            } else {
                if (CC_DEBUG) {
                    AppData.testMode = true
                    AppData.userConnectEnvi = 2
                    LoaclStorage.setNumber("__isDevelopTestMode", 2)
                }
            }
        } else {
            AppData.testMode = true
            LoaclStorage.setNumber("__isDevelopTestMode", 2)
        }
        let customHostDevelop = LoaclStorage.getString("__customHostDevelop", null)
        if (customHostDevelop) {
            AppData.constHostDevelop = customHostDevelop
            AppData.testMode = true
        }
        if (AppData.userConnectEnvi == 2) {
            LoaclStorage.setNumber("__isDevelopTestMode", 2)
        }
        AppData.setServerByData(AppData.userConnectEnvi)
        if (CC_JSB) {
            VersionManager.instance.init()
        }
        if (AppData.testMode || (AppData.devicesModel == "iPhone7,1" || AppData.devicesModel == "iPhone7,2")) {
            // AppData.memoryRecyclingLevel = 2
        }
        // AppData.openInstallData = {
        //     code : 676253,
        //     clubCode : 8888,
        //     clubId : 10
        // }

        cc.log("appData_init：", AppData.userConnectEnvi, AppData.testMode, AppData.assetVersion, AppData.internalAssetVersion)
    }

    static getOpeninstallData(getNew = true) {
        if (!getNew && this.openInstallData != null) {
            return
        }
        AppController.instance.requestOpeninstallData()
    }

    static setOpeninstallData(data : string) {
        try {
            if (data) {
                cc.log("AppData.setOpeninstallData：", data)
                let strArrary = data.split("-")
                if (strArrary && strArrary.length > 0) {
                    AppData.openInstallData = {
                        code : Number.parseInt(strArrary[0])
                    }
                    strArrary.length > 1 && (AppData.openInstallData.clubCode = Number.parseInt(strArrary[1]))
                    strArrary.length > 2 && (AppData.openInstallData.clubId = Number.parseInt(strArrary[2]))
                }
                LogManager.instance.log(`AppData.setOpeninstallData: ${data}`, true)
            }
        } catch (error) {
            AppData.openInstallData = null
        }
    }
}